import { ConnectedPosition } from '@angular/cdk/overlay';
import {
  AfterViewInit,
  Component,
  ContentChild,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
  ViewEncapsulation,
  ChangeDetectionStrategy,
} from '@angular/core';

@Component({
  selector: 'lib-nested-dropdown',
  templateUrl: './nested-dropdown.component.html',
  styleUrls: ['./nested-dropdown.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class NestedDropdownComponent implements OnInit, AfterViewInit {
  @ViewChild('content') childComp: ElementRef;
  @Input() dropData: NestedDropdownData[] = [];
  @Input() selectedValue: boolean;
  @Input() onLeft = false;
  @Input() panelClass = '';
  @Output() nestedClicked = new EventEmitter();
  @Output() parentClicked = new EventEmitter<NestedDropdownData>();
  @Output() droplistToggle = new EventEmitter<boolean>();
  @ContentChild('customDroplist') customDroplist!: TemplateRef<any>;

  isListVisible = false;

  overlayPositions: ConnectedPosition[] = [];

  constructor() {}

  ngOnInit(): void {
    this.overlayPositions = this.buildOverlayPositions();
  }

  ngAfterViewInit(): void {
    this.childComp.nativeElement.addEventListener('click', () => {
      this.isListVisible = !this.isListVisible;
      this.droplistToggle.emit(this.isListVisible);
    });
  }

  handleParentClick(parent: NestedDropdownData) {
    this.parentClicked.emit(parent);
    if (!parent.nested || parent.nested.length === 0) {
      this.isListVisible = false;
      this.droplistToggle.emit(false);
    }
  }

  contentClicked() {}

  handleClickOutside() {
    if (!this.isListVisible) return;
    this.isListVisible = false;
    this.droplistToggle.emit(false);
  }

  handleNestClick(type: any, value: any) {
    this.nestedClicked.emit({ type, value });
    this.isListVisible = false;
    this.droplistToggle.emit(false);
  }

  private buildOverlayPositions(): ConnectedPosition[] {
    const x: 'start' | 'end' = this.onLeft ? 'end' : 'start';
    return [
      { originX: x, originY: 'bottom', overlayX: x, overlayY: 'top', offsetY: 4 },
      { originX: x, originY: 'top', overlayX: x, overlayY: 'bottom', offsetY: -4 },
    ];
  }
}

export interface NestedDropdownData<T = any> {
  title: string;
  name?: string;
  type: T;
  translate?: boolean;
  nested: { text: string; value: string | any; selected?: boolean }[];
}
